import React from 'react';
import MultipleChoiceSurvey from './branch/MultipleChoiceSurvey';
import MultipleChoiceSurveyTracking from './branch/MultipleChoiceSurveyTracking';

export const initViewValues = {
  // currentBranchIndex: '',
  currentIndex: 0,
  bg: { background: 'image' },
  bgImage: {
    background: [
      'https://image.inappmessage.com/sample/defaultGRAYLONGIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultGRAYLONGIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultGRAYLONGIMAGE.webp'
      // 'https://image.inappmessage.com/sample/multiple_choice_survey_01.png',
      // 'https://image.inappmessage.com/sample/multiple_choice_survey_02.png',
      // 'https://image.inappmessage.com/sample/multiple_choice_survey_03.png'
    ]
  },
  bgColor: {
    close: ['#ffffff', '#000000', '#000000'],
    back: ['#ffffff', '#000000', '#000000'],
    background: ['#ffffff', '#ffffff', '#ffffff']
  },
  radius: { selected_option_button: 0, option_button: 0, button: 0 },

  text: {
    title: [
      'Where do you want to go for vacation this year?',
      'How much do you plan to spend on travel?',
      'Planning a trip for a few days and nights?'
    ],
    sub_title: [
      'Fill out the short survey below so we can recommend the perfect trip for you.',
      'Fill out the short survey below so we can recommend the perfect trip for you.',
      'Fill out the short survey below so we can recommend the perfect trip for you.'
    ]
  },
  fontSize: { title: 1.25, sub_title: 0.75 },
  fontWeight: { title: 700, sub_title: 400 },
  color: { title: '#000000', sub_title: '#000000' },
  fontFamily: { title: 'Montserrat', sub_title: 'Montserrat' },
  textAlign: { title: 'center', sub_title: 'center' },

  btnText: {
    option_button: [
      ['Bali', 'Bangkok', 'Guam', 'Cebu'],
      ['up to 80$', 'up to 100$', 'up to 120$', 'Whatever it costs'],
      [
        '2 days, 3 nights',
        '3 days, 4 nights',
        '4 days, 5 nights',
        'up to 6 days'
      ]
    ],
    button: ['Next', 'Next', 'Submit']
  },
  btnFontSize: {
    selected_option_button: 1,
    option_button: 1,
    selected_button: 0.75,
    button: 0.75
  },
  btnFontWeight: {
    selected_option_button: 500,
    option_button: 500,
    selected_button: 500,
    button: 500
  },
  btnColor: {
    selected_option_button: '#ffffff',
    option_button: '#828282',
    selected_button: '#ffffff',
    button: '#ffffff'
  },
  btnBgColorR: {
    selected_option_button: 0,
    option_button: 250,
    selected_button: 0,
    button: 0
  },
  btnBgColorG: {
    selected_option_button: 0,
    option_button: 250,
    selected_button: 0,
    button: 0
  },
  btnBgColorB: {
    selected_option_button: 0,
    option_button: 250,
    selected_button: 0,
    button: 0
  },
  btnBgColorA: {
    selected_option_button: 1,
    option_button: 1,
    selected_button: 1,
    button: 0
  },
  btnFontFamily: {
    selected_option_button: 'Montserrat',
    option_button: 'Montserrat',
    selected_button: 'Montserrat',
    button: 'Montserrat'
  },
  logCustom: {
    type: [
      ['none', 'none', 'none', 'none'],
      ['none', 'none', 'none', 'none'],
      ['none', 'none', 'none', 'none']
    ],
    option_button: [
      ['log_name', 'log_name', 'log_name', 'log_name'],
      ['log_name', 'log_name', 'log_name', 'log_name'],
      ['log_name', 'log_name', 'log_name', 'log_name']
    ]
  }
};

export const initTrackingValues = {
  tracking: {
    close: ['close button 1', 'close button 2', 'close button 3'],
    option_button: [
      ['option 1-1', 'option 1-2', 'option 1-3', 'option 1-4'],
      ['option 2-1', 'option 2-2', 'option 2-3', 'option 2-4'],
      ['option 3-1', 'option 3-2', 'option 3-3', 'option 3-4']
    ],
    button: ['submit button 1', 'submit button 2', 'submit button 3']
  }
};

export const init_editor_values_multiple_choice_survey = {
  branch: [1],
  multi: [1, 4],
  contents: {
    bgImageType: ['background'],
    bgColorType: ['close', 'back', 'background'],
    bg: ['background'],
    bgColor: ['close', 'back'],

    textType: ['title', 'sub_title'],
    text: ['title', 'sub_title'],
    fontSize: ['title', 'sub_title'],
    fontWeight: ['title', 'sub_title'],
    color: ['title', 'sub_title'],
    fontFamily: ['title', 'sub_title'],
    textAlign: ['title', 'sub_title']
  },
  buttons: {
    btnType: [
      'selected_option_button',
      'option_button',
      'selected_button',
      'button'
    ],
    optionText: ['option_button'],
    btnText: [undefined, undefined, undefined, 'button'],
    btnFontSize: [
      'selected_option_button',
      'option_button',
      'selected_button',
      'button'
    ],
    btnFontWeight: [
      'selected_option_button',
      'option_button',
      'selected_button',
      'button'
    ],
    btnColor: [
      'selected_option_button',
      'option_button',
      'selected_button',
      'button'
    ],
    btnBgColor: [
      'selected_option_button',
      'option_button',
      'selected_button',
      'button'
    ],
    btnFontFamily: [
      'selected_option_button',
      'option_button',
      'selected_button',
      'button'
    ],
    radius: ['selected_option_button', 'option_button', undefined, 'button'],
    radiusMax: [30, 30, undefined, 30]
  },
  trackings: {
    trackingType: ['close', 'option_button', 'button'],
    logCustomType: ['type', 'option_button']
  }
};

export const ViewTemplates = {
  '': <MultipleChoiceSurvey />
};

export const TrackingTemplates = {
  '': <MultipleChoiceSurveyTracking />
};
